import Filter from './filters/Filter.view';
import FiltersCollection from './filters/Filters.collection';

import SelectedFilters from './filters/SelectedFilters.view';
import SelectedFiltersCollection from './filters/SelectedFilters.collection';

import itemsCollection from './grid/Items.collection';
import Grid from './grid/Items.view';

import './form/submit.js';

let sfspcaUserContent = window.sfspcaUserContent;
let _ = window._;
let $ = jQuery;
let Backbone = window.Backbone;

window.sfscpaVent = _.extend({}, Backbone.Events);

$(document).on('sfspca/user-stories/grid-init', () => {

  if($('.js-userContent').length > 1) {
    console.log('There are more than one view. Removing the surplus!');
    $('.js-userContent').not(':first()').remove();
  }

  if ($('.js-userContent').data('user-story-init')) {
    return;
  }

  $('.js-userContent').data('user-story-init', 1);

  let selectedFiltersCollection = new SelectedFiltersCollection;

  new SelectedFilters({
    collection: selectedFiltersCollection,
  });

  _.each(sfspcaUserContent.filters, (filter) => {
    let fieldset = $('<fieldset />').html(new Filter({
      collection: new FiltersCollection(filter.terms),
      taxonomy: filter.taxonomy
    }).$el);

    $('.js-userContent__filters').append(fieldset);
  });

  new Grid({
    collection: new itemsCollection,
    filters: selectedFiltersCollection
  });
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/userContent.js